import { useLocation } from 'react-router-dom';

import PostCard from './PostCard';
import Spinner from './Spinner';

import { usePostsContext } from '../hooks/usePostsContext';
import CreatePost from './CreatePost';
import { useEffect, useMemo } from 'react';

export default function Posts({ feedType, userId }) {  
  const { pathname } = useLocation()
  const { data, error, isLoading, refetchPosts } = usePostsContext()

  const dependencies = useMemo(() => [userId, feedType], [userId, feedType]);

  useEffect(() => {
    refetchPosts(userId, feedType)
  }, dependencies)

  
  if (isLoading) return <Spinner marginSize='100px' />
  if (error) return <p>{error.message}</p>

  return (
    <>
      {pathname === '/' && <CreatePost refetch={refetchPosts} />}

      {data?.posts.length > 0 ? (
        <div className='mt-4'>
          <div className='my-2 mx-auto rfs-2 text-body text-center'>{data?.posts.length} {data?.posts.length === 1 ? 'post' : 'posts'}</div>
          {data?.posts.map((post) => (
            <PostCard key={post.id} post={post} />
          ))}
        </div>
      ) : (
        <p className="text-center text-body rfs-2 m-4">No Posts</p>
      )}
    </>
  )
}
